import React, { useEffect } from 'react'
import background from '../images/Group 118@2x.png'
import '../styles/email-signup.scss'

const EmailSignup = () => {

    return (
        <div className="email-signup" style={{ backgroundImage: `url('${background}')` }}>
            <div className="container email-signup__inner">
                <h2>Bible Insights by Email</h2>
                <p>Sign up for learning delivered to your inbox weekly</p>
                <form
                    action="https://bibletolife.us21.list-manage.com/subscribe/post?u=86dc365188714eaf189d870dc&amp;id=5844b095ce&amp;f_id=00cec5e1f0"
                    method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form"
                    className="validate" target="_blank" noValidate>
                    <div className="ao-row" id="mc_embed_signup_scroll">
                        <div className="mc-field-group">
                            <input type="email" name="EMAIL" className="required email"
                                   id="mce-EMAIL" placeholder="Email*" required/>
                            <span id="mce-EMAIL-HELPERTEXT" className="helper_text"/>
                        </div>
                        <div id="mce-responses" className="clear">
                            <div className="response" id="mce-error-response"/>
                            <div className="response" id="mce-success-response"/>
                        </div>
                        <div className="address-field" aria-hidden="true"><input
                            type="text" name="b_86dc365188714eaf189d870dc_5844b095ce" tabIndex="-1"/></div>
                        <div className="clear"><input type="submit" value="Subscribe" name="subscribe"
                                                      id="mc-embedded-subscribe" className="button"/></div>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default EmailSignup